const getting_old = `Vanheneminen voi olla haastavaa.
Kun ihmiset vanhenevat, heidän kehonsa ei välttämättä toimi samalla tavalla kuin ennen ja he saattavat tarvita enemmän apua arjen asioissa.
Jotkut vanhemmat ihmiset saattavat tuntea itsensä yksinäisiksi tai surullisiksi, koska heidän ystävänsä ja perheensä eivät ole niin paljon lähellä.
He saattavat kaipaamaan asioita, joita he tekivät nuorempana, kuten urheilua tai pitkiä kävelylenkkejä.
Terveysongelmat voivat vaikeuttaa myös iäkkäitä ihmisiä.
He saattavat joutua ottamaan lääkkeitä joka päivä tai käymään lääkärissä useammin.
Tämä voi olla väsyttävää ja saada heidät tuntemaan olonsa heikoksi.
On kuitenkin tärkeää muistaa, että vanhenemisessa on myös hyvät puolensa.
Vanhemmilla ihmisillä on paljon viisautta ja kokemusta, jonka he voivat jakaa muiden kanssa.
He ovat nähneet elämässään monia asioita ja voivat opettaa muille arvokkaita opetuksia.
On tärkeää, että kaikki kohtelevat iäkkäitä ihmisiä kunnioittavasti ja ystävällisesti.
He ansaitsevat elää elämänsä arvokkaasti ja onnellisesti.
On myös tärkeää, että yhteisöt tarjoavat tukea ja hoitoa iäkkäille ihmisille, jotta he voivat tuntea olevansa rakastettu ja arvostettu.`;

export default getting_old;